// Design book: https://www.figma.com/design/w5Fb7jkaFoIdI3au7PIpgx/Service-Seeking-Design-Book?node-id=196-115&m=dev
// Figma ↔ props mapping: doc/design-system/figma-map.md (Alerts)
import React from 'react'

import DismissTarget from 'tailwind/common/components/DismissTarget'

// Static class map so Tailwind purge includes alert colours (see figma-map.md Alerts).
const ALERT_COLOR_CLASSES = {
  dark: {
    container: 'text-base-gray-900 bg-base-gray-50',
    icon: 'text-base-gray-900',
  },
  info: {
    container: 'text-base-blue-900 bg-base-blue-50',
    icon: 'text-base-blue-900',
  },
  success: {
    container: 'text-base-green-900 bg-base-green-50',
    icon: 'text-base-green-900',
  },
  warning: {
    container: 'text-base-gold-900 bg-base-gold-50',
    icon: 'text-base-gold-900',
  },
  default: {
    container: 'text-base-red-900 bg-base-red-50',
    icon: 'text-base-red-900',
  },
}

const alertColorClasses = (name) => {
  switch (name) {
  case 'dark':
    return ALERT_COLOR_CLASSES.dark
  case 'info':
    return ALERT_COLOR_CLASSES.info
  case 'success':
    return ALERT_COLOR_CLASSES.success
  case 'warning':
    return ALERT_COLOR_CLASSES.warning
  default:
    return ALERT_COLOR_CLASSES.default
  }
}

const Alert = (props) => {
  const colorClasses = alertColorClasses(props.name)

  const defaultMessage = () => {
    return (
      <span>
        An unknown error has occurred. Please contact support at{' '}
        <a href='mailto:support@serviceseeking.com.au' className='font-semibold'>
          support@serviceseeking.com.au
        </a>
      </span>
    )
  }

  // Note: `my-4` is retained here to avoid affecting existing pages that use this component.
  // TODO: In https://serviceseeking.atlassian.net/browse/REB-2324, remove `my-4` completely and update all affected pages accordingly.
  const alertId = props.alertId || 'alert-banner'

  return (
    <div id={alertId} className={`flex w-full items-center p-3 ${props.marginY || 'my-4'} rounded-5 self-stretch ${colorClasses.container}`} role='alert'>
      <div className='flex items-center gap-2 flex-1'>
        <hero-icon-outline name={`${props.icon || 'information-circle'}`} width='24' height='24' class={`flex-shrink-0 ${colorClasses.icon}`}></hero-icon-outline>
        <div className='text-sm font-medium'>
          { props.message || defaultMessage()}
        </div>
      </div>
      {
        props.canDismiss &&
        <DismissTarget targetId={alertId} iconColor={colorClasses.icon} onDismiss={props.onDismiss} />
      }
    </div>
  )
}

export default Alert
